export enum AuthActionType {
  SetSessionId = 'auth/SET_SESSION_ID',
  SetBearer = 'auth/SET_BEARER',
  ClearAuth = 'auth/CLEAR_AUTH',
}
